import React from 'react';

const Spinner = ({addClass='', text=''}) => (
	<div className={ `spinner${addClass.length>0 ? (' ' + addClass) : ''}` }>
		<div className="bounces">
			<div className="bounce1"></div>
			<div className="bounce2"></div>
			<div className="bounce3"></div>
		</div>
		{text && <div className="spinner-text">{text}</div>}
	</div>);

export default Spinner;

